import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '@avangard/ui/core';

import { useNavigate, createRouteUrl } from '@lib/routing';
import { SchoolCreateForm } from './school-create-form';

import type { ModalProps } from '@avangard/ui/core';
import type { SchoolCreateFormProps } from './school-create-form';

type SchoolFormModalProps = Omit<ModalProps, 'title' | 'children'> &
    Pick<SchoolCreateFormProps, 'refetchQueries'> & {
        redirectPathOnSuccess: string;
    };

const SchoolCreateFormModal = (props: SchoolFormModalProps): React.ReactElement => {
    const { redirectPathOnSuccess, refetchQueries, onClose, ...otherProps } = props;

    const { t } = useTranslation(['schools']);

    const navigate = useNavigate();

    const handleCancel = (schoolId: string) => {
        onClose();
        navigate(createRouteUrl(redirectPathOnSuccess, { id: schoolId }));
    };

    return (
        <Modal title={t('schools:add_school.title_long') ?? ''} onClose={onClose} {...otherProps}>
            <SchoolCreateForm
                refetchQueries={refetchQueries}
                onCancel={onClose}
                onSuccess={handleCancel}
            />
        </Modal>
    );
};

export { SchoolCreateFormModal };
